import { Button } from "@omni/ui/components/Button/button.component";
import { useMapped } from "@omni/utils/context/mapped.context";
import { cn } from "@omni/utils/styles";

import { useFaqContext } from "@/components/General/Faq/context/faq.context";

type Props = {
    className?: string;
};

export const CategoryButton = ({ className }: Props) => {
    const { index } = useMapped();
    const { categories, selection, onSelectCategory } = useFaqContext();

    const category = categories[index];

    const active = category.id === selection.category.id;

    const handleOnClick = () => {
        if (active) return;

        onSelectCategory(category);
    };

    return (
        <Button
            className={cn(
                "tw:p-0 tw:text-left",
                {
                    "tw:text-grey-input tw:hover:text-grey-input tw:focus:text-grey-input tw:no-underline tw:hover:no-underline tw:focus:no-underline tw:cursor-default!":
                        active
                },
                className
            )}
            color={"link"}
            onClick={handleOnClick}
        >
            {category.title}
        </Button>
    );
};
